module.exports = __webpack_public_path__ + "img/black.190147dc.jpeg";